import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Wordmark } from "./brand.tsx";

export function Logo({ className = "" }: { className?: string }) {
  return (
    <Link to="/" className={`inline-flex items-center ${className}`}>
      <Wordmark size={18} />
    </Link>
  );
}

export function Page({
  children,
  testid,
  wide = false,
  bare = false,
}: {
  children: ReactNode;
  testid?: string;
  wide?: boolean;
  /** Self-contained pages (the blend/dashboard sheet has its own masthead +
   *  barcode footer) opt out of the app header/footer to avoid a nested logo. */
  bare?: boolean;
}) {
  if (bare) {
    return (
      <div data-testid={testid} className="bg-paper-50">
        <main className="mx-auto w-full max-w-app px-3 pb-3 pt-3 sm:px-5 sm:pb-4 sm:pt-5">
          {children}
        </main>
      </div>
    );
  }
  return (
    <div data-testid={testid} className="min-h-full bg-paper-50">
      <header className="border-b border-divider">
        <div className="mx-auto flex max-w-app items-center justify-between px-4 py-4 sm:px-6">
          <Logo />
          <span className="mono-meta">Two movie libraries · one screening</span>
        </div>
      </header>
      <main
        className={`mx-auto w-full px-4 py-6 sm:px-6 sm:py-8 ${wide ? "max-w-app" : "max-w-2xl"}`}
      >
        {children}
      </main>
      <Footer />
    </div>
  );
}

export function Footer() {
  return (
    <footer className="mx-auto max-w-app px-4 py-8 text-xs text-ink-400 sm:px-6">
      <div className="border-t border-divider pt-4">
        Works with your Letterboxd export · Film data & posters from{" "}
        <a href="https://www.themoviedb.org/" target="_blank" rel="noreferrer">
          TMDB
        </a>
        . Not affiliated with Letterboxd or TMDB. ·{" "}
        <Link to="/privacy">Privacy</Link>
      </div>
    </footer>
  );
}

export function Skeleton({ className = "" }: { className?: string }) {
  return <div className={`rounded-md shimmer ${className}`} />;
}
